import React from "react";
import { FormProvider } from "react-hook-form";
import { Create } from "@refinedev/mui";

import { BannerForm } from "@modules/banners/components/BannerForm";
import { useBannerCreateForm } from "./controller";

export const BannerCreate = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending } = useBannerCreateForm();

  return (
    <Create
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
    >
      <FormProvider {...methods}>
        <BannerForm />
      </FormProvider>
    </Create>
  );
});
